import { trigger, transition, style, animate, query, group } from '@angular/animations';

export const fadeAnimation = trigger('routeAnimations', [
  transition('* <=> *', [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        opacity: 0
      })
    ]),
    query(':leave', [
      animate('300ms ease-in-out', style({ opacity: 0 }))
    ]),
    query(':enter', [
      style({ opacity: 0 }),
      animate('300ms ease-in-out', style({ opacity: 1 }))
    ])
  ])
]);
